import React from 'react';
import { Input } from '~/shared/components';
import { Grid } from '~/shared/components/Grid';
import { Fields } from '~/features/checkout/models/fields';
import { useTranslation } from '~/shared/utils/translation';

export const EditAddressForm = () => {
    const { translate } = useTranslation();
    return (
        <>
            <Grid
                data-testid="edit-delivery-address"
                flow="column"
                columns="1fr 1fr"
                columnGap="extrasmall"
            >
                <Input
                    name={Fields.FirstName}
                    label={translate('forms.fields.form.firstName')}
                    maxLength={24}
                    required
                    data-testid="first-name"
                />

                <Input
                    name={Fields.LastName}
                    label={translate('forms.fields.form.lastName')}
                    maxLength={24}
                    required
                    data-testid="last-name"
                />
            </Grid>

            <Input
                name={Fields.Address1}
                label={translate('forms.fields.form.address1')}
                maxLength={50}
                required
                data-testid="address"
            />

            <Grid flow="column" columns="1fr 2fr" columnGap="extrasmall">
                <Input
                    name={Fields.PostalCode}
                    label={translate('forms.fields.form.postalcode')}
                    maxLength={4}
                    required
                    data-testid="postal-code"
                />

                <Input
                    name={Fields.City}
                    label={translate('forms.fields.form.city')}
                    disabled
                    required
                />
            </Grid>
            <Input
                name={Fields.Phone}
                label={translate('forms.fields.form.mobile')}
                type="phone"
                data-testid="phone-input"
                required
            />
        </>
    );
};
